const GENERIC_TITLE = "We got an unexpected error";

const STATUS_CODE_TO_TITTLE = {
  400: "Invalid Request",
  401: "Authentication Required",
  403: "Access Denied",
  404: "Not Found",
};

export const mapErrorToTittle = (error) => {
  const response = error.response;
  if (!response || response.status >= 500) {
    return GENERIC_TITLE;
  }

  const tittle = STATUS_CODE_TO_TITTLE[response.status];

  return tittle || GENERIC_TITLE;
};
